const FIELD_SELECTOR = 'input.field-input[type="date"], select.field-input';
function getFieldInput(target) {
  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return null;
  return target.matches(FIELD_SELECTOR) ? target : null;
}
function hasFieldValue(input) {
  if (input instanceof HTMLSelectElement) {
    return input.value !== "" && input.value !== "---" || input.selectedIndex === -1;
  }
  return input.value !== "";
}
function updateFieldSelectedState(input) {
  const hasValue = hasFieldValue(input);
  if (input.hasAttribute("selected") === hasValue) return;
  input.toggleAttribute("selected", hasValue);
}
function updateFieldFromEvent(event) {
  const input = getFieldInput(event.target);
  if (!input) return;
  updateFieldSelectedState(input);
  if (event.type === "change" && input instanceof HTMLSelectElement && input.hasAttribute("data-open")) {
    input.removeAttribute("data-open");
  }
}
function openSelect(event) {
  const input = getFieldInput(event.target);
  if (!(input instanceof HTMLSelectElement) || input.hasAttribute("data-open")) return;
  input.setAttribute("data-open", "");
}
function closeSelect(event) {
  const input = getFieldInput(event.target);
  if (!(input instanceof HTMLSelectElement) || !input.hasAttribute("data-open")) return;
  input.removeAttribute("data-open");
}
function updateFields(root = document) {
  root.querySelectorAll(FIELD_SELECTOR).forEach(updateFieldSelectedState);
}
updateFields();
document.addEventListener("focusin", updateFieldFromEvent);
document.addEventListener("input", updateFieldFromEvent);
document.addEventListener("change", updateFieldFromEvent);
document.addEventListener("mousedown", openSelect);
document.addEventListener("blur", closeSelect, true);
document.addEventListener("reset", (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  requestAnimationFrame(() => updateFields(event.target));
});
let areaCodeCountryRequest;
const initializedAreaCodes = new WeakSet();
function setAreaCodeDefaults(root = document) {
  const inputs = [...root.querySelectorAll(".field-area-code select")].filter(
    (input) => !input.value && !initializedAreaCodes.has(input)
  );
  if (!inputs.length) return;
  areaCodeCountryRequest ??= fetch(
    (window.Shopify?.routes?.root || "/") +
      "browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false",
    { cache: "no-store", signal: AbortSignal.timeout(5000) }
  ).then((response) => response.ok ? response.json() : null).then((data) => {
    const country = data?.detected_values?.country?.handle;
    return typeof country === "string" && /^[A-Z]{2}$/.test(country) ? country : null;
  }).catch(() => null);
  for (const input of inputs) {
    initializedAreaCodes.add(input);
    let touched = document.activeElement === input;
    input.addEventListener("focus", () => { touched = true; }, { once: true });
    areaCodeCountryRequest.then((country) => {
      if (!country || touched || input.value || !input.isConnected) return;
      const option = [...input.options].find((item) => item.dataset.countryCode === country);
      if (!option) return;
      input.value = option.value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}
setAreaCodeDefaults();
document.addEventListener("shopify:section:load", (event) => {
  if (event.target instanceof Element) setAreaCodeDefaults(event.target);
});
export {
  updateFieldSelectedState
};

